import React from 'react';
import {
  Home, Map, Plus, MessageCircle, User, Bell, Search, SlidersHorizontal,
  Footprints, MapPin, Shield, FileText, Lock, Coins, Check, ArrowUp,
  ChevronRight, ChevronDown, ChevronLeft, Phone, Info, Star, Wallet, X, LogOut, Send,
} from 'lucide-react';

const wrap = (Comp) => ({ size = 18, stroke = 'currentColor', sw = 1.75, style }) =>
  <Comp size={size} color={stroke} strokeWidth={sw} style={style} />;

export const Icon = {
  home: wrap(Home),
  map: wrap(Map),
  plus: wrap(Plus),
  chat: wrap(MessageCircle),
  user: wrap(User),
  bell: wrap(Bell),
  search: wrap(Search),
  filter: wrap(SlidersHorizontal),
  walk: wrap(Footprints),
  pin: wrap(MapPin),
  shield: wrap(Shield),
  doc: wrap(FileText),
  lock: wrap(Lock),
  coin: wrap(Coins),
  check: wrap(Check),
  arrowUp: wrap(ArrowUp),
  chevronR: wrap(ChevronRight),
  chevronD: wrap(ChevronDown),
  chevronL: wrap(ChevronLeft),
  phone: wrap(Phone),
  info: wrap(Info),
  starO: wrap(Star),
  wallet: wrap(Wallet),
  x: wrap(X),
  logout: wrap(LogOut),
  send: wrap(Send),
};
